<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" title="Volver" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" title="Guardar" type="button" class="btn btn-outline-success" (click)="guardarTexto()"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Atestación Fitosanitaria {{refAtestFito}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudAtestFito | IconoTipoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudAtestFito | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <div class="card-header"></div>
                    <div class="card-body-detalle">
                        <div class="row" style="margin-bottom:15px;">
                            <div class="form-group col-md-12">
                                <!-- required-field -->
                                <label class="col-form-label" for="inpTextoAtestFito">Solicitud de Atestación Fitosanitaria</label>
                                <textarea formControlName="TextoAtestFito" name="TextoAtestFito" title="" class="form-control"
                                          id="inpTextoAtestFito" type="text" value="" autoResize="autoResize" rows="12"></textarea>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom:15px;">
                            <div class="form-group col-md-12">
                                <!-- required-field -->
                                <label class="col-form-label" for="inpTextoAtestFitoUsuarioCaAc">Atestación Fitosanitaria</label>
                                <textarea formControlName="TextoAtestFitoUsuarioCaAc" name="TextoAtestFitoUsuarioCaAc" title="" class="form-control"
                                          id="inpTextoAtestFitoUsuarioCaAc" type="text" value="" autoResize="autoResize" rows="12"></textarea>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
